export function client(data) {
    const { custom } = data;

    const {
        program,
        program_required,

        program_own_variants,
        program_save_own_variants,
        program_level_own_variants,
        program_level_save_own_variants,

        language,
        language_required,

        language_own_variants,
        language_save_own_variants,

        language_level_own_variants,
        language_level_save_own_variants,
    } = custom || {};

    return {
        skills: {
            program: {
                show: !!program,
                required: !!program_required,
                param: {
                    custom: !!program_own_variants,
                    saveCustom: !!program_save_own_variants,
                },
                level: {
                    custom: !!program_level_own_variants,
                    saveCustom: !!program_level_save_own_variants,
                },
            },
            language: {
                show: !!language,
                required: !!language_required,
                param: {
                    custom: !!language_own_variants,
                    saveCustom: !!language_save_own_variants,
                },
                level: {
                    custom: !!language_level_own_variants,
                    saveCustom: !!language_level_save_own_variants,
                },
            },
        },
    };
}

export function server(data) {
    const { program, language } = data.skills;

    const programFields = (() => {
        const { show, required, param, level } = program;

        return {
            program: show,
            program_required: required,

            program_own_variants: param.custom,
            program_save_own_variants: param.saveCustom,
            program_level_own_variants: level.custom,
            program_level_save_own_variants: level.saveCustom,
        };
    })();

    const languageFields = (() => {
        const { show, required, param, level } = language;

        return {
            language: show,
            language_required: required,

            language_own_variants: param.custom,
            language_save_own_variants: param.saveCustom,
            language_level_own_variants: level.custom,
            language_level_save_own_variants: level.saveCustom,
        };
    })();

    return {
        custom: {
            ...programFields,
            ...languageFields,
        },
    };
}
